var map = {
	"./shared/benchmarks/benchmark-percentile-chart/index.js": [
		85012,
		961,
		1699,
		2664,
		5012
	],
	"./shared/benchmarks/benchmarks-list/index.js": [
		53962,
		961,
		2664,
		3962
	],
	"./shared/benchmarks/benchmarks-selector/index.js": [
		7214,
		961,
		1699,
		2664,
		6144,
		7214
	],
	"./shared/benchmarks/config/index.js": [
		22531,
		1699,
		2531
	],
	"./shared/benchmarks/hooks/index.js": [
		62036,
		2036
	],
	"./shared/benchmarks/screens/index.js": [
		78693,
		1699,
		1074
	],
	"./shared/benchmarks/simple-store/index.js": [
		23755,
		3755
	],
	"./shared/copy-to-clipboard/index.js": [
		97668,
		2664,
		7668
	],
	"./views/index.js": [
		34479
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64501;
module.exports = webpackAsyncContext;